import { useTheme } from "@mui/material/styles";
import { useBranding } from "./useBranding";

/** Brand colors from the active MUI theme (synced with URF globalBrandingChange). */
export function useBrandThemeColors() {
  const theme = useTheme();
  const { config } = useBranding();

  return {
    primaryColor: theme.palette.primary.main,
    primaryFontColor: theme.palette.primary.contrastText,
    headerBackgroundColor:
      config.themeAndColors.headerBackgroundColor ?? theme.palette.primary.main,
  };
}
